import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Growl } from 'primereact/growl';
import { ScrollPanel } from 'primereact/scrollpanel';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioUsuario from '../servicios/ServicioUsuario';
class RecuperarContrasena extends Component {
    constructor() {
        super();
        this.state = {
            usuarioRecupera: {},
            errores: {},
            mostrarModalRecuperaPass: false,
            verificaCapchaRecupera: false
        }
        this.mostrarModalRecuperarContrasena = this.mostrarModalRecuperarContrasena.bind(this);
        this.recuperaContrasena = this.recuperaContrasena.bind(this);
        this.cerrarModal = this.cerrarModal.bind(this);
        this.cargarCapchap = this.cargarCapchap.bind(this);
        this.correctoCapchapRecupera = this.correctoCapchapRecupera.bind(this);
       
        this.recaptchaLoad = this.recaptchaLoad.bind(this);
        this.verificaCapchaCorrecto = this.verificaCapchaCorrecto.bind(this);
    }
    asignarValoresObjeto = (event) => {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);
    }

    mostrarModalRecuperarContrasena() {
        this.setState({
            mostrarModalRecuperaPass: true

        });
    }
    cerrarModal() {
        this.setState({
            mostrarModalRecuperaPass: false

        });
    }
    cargarCapchap() {
        console.log("c");

    }
    correctoCapchapRecupera(response) {
        if (response) {
            this.setState({
                verificaCapchaRecupera: true
            });
        }
    }
    validarFormulario = (usuario) => {
        const errores = {};
        if (!usuario.usuario)
            errores.usuario = "El usuario es requerido";

        return errores;
    }
    validarUsuario= () => {
        const { usuarioRecupera} = this.state;
        servicioUsuario.buscarUsuarioNombre(usuarioRecupera).then(response => {
          
            if(response.data===false){
                this.setState({ usuarioRecupera: {}});
                this.growl.show({ severity: 'error', summary: 'Error', detail: 'El usuario o correo no existe' });
                
            }else{
                this.recuperaContrasena(); 
            }
         

        }).catch(error => {
           
        });
   
    }
    recuperaContrasena() {
        const { usuarioRecupera } = this.state;
        
       
        const validacion = this.validarFormulario(usuarioRecupera);
        this.setState({ errores: validacion });
       
        
        if (!Object.keys(validacion).length) {
            //if (verificaCapchaRecupera == true) {
                servicioUsuario.recuperarContrasena(usuarioRecupera).then(response => {

                    this.setState({ usuarioRecupera: {}, mostrarModalRecuperaPass: false });
                    this.growl.show({ severity: 'success', summary: 'Exito', detail: 'Se envío la contraseña a su correo.' });

                }).catch(error => {

                });
            //}
        }
    
    }
    recaptchaLoad(){
        console.log("captchap");
    }
    verificaCapchaCorrecto(response){
     if(response){
        this.setState({
            verificaCapchap: true
        });
     }
    }
    render() {
        const { usuarioRecupera, errores } = this.state;
        return (
            <div><Button onClick={this.mostrarModalRecuperarContrasena} label="Recuperar contraseña" className="p-button-rounded p-button-warning" />
                <Growl ref={(el) => this.growl = el} />
                <Dialog header="Recupera la Contraseña" visible={this.state.mostrarModalRecuperaPass} style={{ width: '30vw' }} onHide={(e) => this.setState({ mostrarModalRecuperaPass: false })} maximizable>
                    <ScrollPanel style={{ width: '100%', height: '180px' }}>
                        <div className="p-grid p-fluid">
                            <div className="p-col-12 p-md-12">
                                <h4>Ingresar usuario o correo electrónico:</h4>
                                <InputText id="usuario" name="usuarioRecupera.usuario"  value={usuarioRecupera.usuario || ''} className={errores.usuario ? 'p-error' : ''} onChange={this.asignarValoresObjeto} />
                                {errores.usuario ? <div> <Message severity="error" text={errores.usuario} /> </div> : null}
                           
                            </div>
                            <div className="p-col-12 p-md-12">
                          
                           
                            </div>



                        </div>

                        <br />
                        <div className="p-grid" style={{ width: "100%" }}>
                            <div className="p-col"></div>
                            <div className="p-col"></div>
                            <div className="p-col ">
                                <Button label="recuperar" onClick={this.validarUsuario} icon="pi pi-check" />
                            </div>
                            <div className="p-col">
                                <Button label="Cancelar" onClick={this.cerrarModal} icon="pi pi-times" className="p-button-danger" />
                            </div>
                        </div>
                    </ScrollPanel>
                </Dialog>
            </div>
        );
    }
}
export default RecuperarContrasena;